/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line import/no-extraneous-dependencies
import { graphql, rest } from 'msw';
import { faker } from '@faker-js/faker';
import { API_ORIGIN } from '../config';
import {
  GetBillingAccountUserQueryResult,
  GetBillingAccountUserQueryVariables,
  GetTaxExemptionsQueryResult,
  GetTaxExemptionsQueryVariables,
  DeleteTaxExemptionMutationVariables,
  DeleteTaxExemptionMutationResult,
  SetBillingAccountAddressMutationResult,
  SetBillingAccountAddressMutationVariables,
  AddTaxExemptionUrlMutationResult,
  AddTaxExemptionUrlMutationVariables,
  CreateCreditApplicationMutationResult,
  CreateCreditApplicationMutationVariables,
  HasUserSubmittedApplicationQueryResult,
  HasUserSubmittedApplicationQueryVariables,
  GetBillingAccountFinancialsQueryResult,
  GetBillingAccountFinancialsQueryVariables,
  PayInvoicesMutationResult,
  PayInvoicesMutationVariables,
  IntacctInvoice,
  IntacctPayment,
  IntacctCreditMemo,
} from '../schema/generated/schema';

const userId = '12345';

export const getBillingAccountUserQueryResponse = {
  getBillingAccountUser: {
    billingAccounts: {
      edges: [
        {
          node: {
            id: 'B12345',
            createdBy: '12345',
            name: faker.person.fullName(),
            creditLimitInCents: 1000000,
            availableCreditInCents: 100000,
            creditTerm: 'N30',
            status: 'ACTIVE',
            contact: {
              name: faker.person.fullName(),
              emailAddress: faker.internet.email(),
              phoneNumber: faker.phone.number('###-###-####'),
              address: {
                street1: faker.location.streetAddress(),
                street2: faker.location.secondaryAddress(),
                city: faker.location.city(),
                state: faker.location.state({ abbreviated: true }),
                province: '',
                zipcode: faker.location.zipCode(),
                country: 'United States',
              },
            },
          },
        },
      ],
    },
  },
};

export const getBillingAccountWithoutTermsUserQueryResponse = {
  getBillingAccountUser: {
    billingAccounts: {
      edges: [
        {
          node: {
            id: 'B12345',
            createdBy: '12345',
            name: faker.company.name(),
            creditLimitInCents: 0,
            availableCreditInCents: null,
            creditTerm: null,
            status: 'SUSPENDED',
            contact: {
              name: faker.person.fullName(),
              emailAddress: faker.internet.email(),
              phoneNumber: faker.phone.number('###-###-####'),
              address: {
                street1: faker.location.streetAddress(),
                city: faker.location.city(),
                state: faker.location.state({ abbreviated: true }),
                province: '',
                zipcode: faker.location.zipCode(),
                country: 'United States',
              },
            },
          },
        },
      ],
    },
  },
};

export const getBillingAccountsUserQuerySuccess = {
  getBillingAccountUser: {
    billingAccounts: {
      edges: [
        {
          node: {
            id: 'B13010',
            createdBy: null,
            name: 'Bread Pitt Bakery, LLC',
            creditLimitInCents: 85000000,
            availableCreditInCents: 71750690,
            creditTerm: 'N120',
            status: 'ACTIVE',
            contact: {
              name: 'Brad Pitt',
              emailAddress: 'bread@bakery.com',
              phoneNumber: faker.phone.number('###-###-####'),
              address: {
                street1: faker.location.streetAddress(),
                street2: faker.location.secondaryAddress(),
                city: faker.location.city(),
                state: faker.location.state({ abbreviated: true }),
                province: '',
                zipcode: faker.location.zipCode(),
                country: 'United States',
                __typename: 'BillingAccountAddress',
              },
              __typename: 'BillingAccountContact',
            },
            __typename: 'BillingAccount',
          },
          __typename: 'UserBillingAccountEdge',
        },
        {
          node: {
            id: 'B56359',
            createdBy: '09091',
            name: faker.company.name(),
            creditLimitInCents: 5000000,
            availableCreditInCents: 4287877,
            creditTerm: 'NET 60',
            status: 'ACTIVE',
            contact: {
              name: faker.person.fullName(),
              emailAddress: faker.internet.email(),
              phoneNumber: faker.phone.number('###-###-####'),
              address: {
                street1: faker.location.streetAddress(),
                street2: faker.location.secondaryAddress(),
                city: faker.location.city(),
                state: faker.location.state({ abbreviated: true }),
                province: '',
                zipcode: faker.location.zipCode(),
                country: 'United States',
                __typename: 'BillingAccountAddress',
              },
              __typename: 'BillingAccountContact',
            },
            __typename: 'BillingAccount',
          },
          __typename: 'UserBillingAccountEdge',
        },
        {
          node: {
            id: 'B58241',
            createdBy: '09091',
            name: faker.company.name(),
            creditLimitInCents: 0,
            availableCreditInCents: 0,
            creditTerm: null,
            status: 'SUSPENDED',
            contact: {
              name: faker.person.fullName(),
              emailAddress: faker.internet.email(),
              phoneNumber: faker.phone.number('###-###-####'),
              address: {
                street1: faker.location.streetAddress(),
                street2: faker.location.secondaryAddress(),
                city: faker.location.city(),
                state: faker.location.state({ abbreviated: true }),
                province: '',
                zipcode: faker.location.zipCode(),
                country: 'United States',
                __typename: 'BillingAccountAddress',
              },
              __typename: 'BillingAccountContact',
            },
            __typename: 'BillingAccount',
          },
          __typename: 'UserBillingAccountEdge',
        },
        {
          node: {
            id: 'B53857',
            createdBy: '09091',
            name: 'Pita Pan Inc.',
            creditLimitInCents: null,
            availableCreditInCents: null,
            creditTerm: null,
            status: 'SUSPENDED',
            contact: {
              name: 'Peter Pan',
              emailAddress: 'sammichs@pita.com',
              phoneNumber: faker.phone.number('###-###-####'),
              address: {
                street1: faker.location.streetAddress(),
                street2: faker.location.secondaryAddress(),
                city: faker.location.city(),
                state: faker.location.state({ abbreviated: true }),
                province: '',
                zipcode: faker.location.zipCode(),
                country: 'United States',
                __typename: 'BillingAccountAddress',
              },
              __typename: 'BillingAccountContact',
            },
            __typename: 'BillingAccount',
          },
          __typename: 'UserBillingAccountEdge',
        },
        {
          node: {
            id: 'B58698',
            createdBy: '09091',
            name: faker.company.name(),
            creditLimitInCents: 5000000,
            availableCreditInCents: 3484344,
            creditTerm: 'NET 60',
            status: 'ACTIVE',
            contact: {
              name: faker.person.fullName(),
              emailAddress: faker.internet.email(),
              phoneNumber: faker.phone.number('###-###-####'),
              address: {
                street1: faker.location.streetAddress(),
                street2: faker.location.secondaryAddress(),
                city: faker.location.city(),
                state: faker.location.state({ abbreviated: true }),
                province: '',
                zipcode: faker.location.zipCode(),
                country: 'United States',
                __typename: 'BillingAccountAddress',
              },
              __typename: 'BillingAccountContact',
            },
            __typename: 'BillingAccount',
          },
          __typename: 'UserBillingAccountEdge',
        },
      ],
      __typename: 'UserBillingAccountConnection',
    },
    __typename: 'User',
  },
};

export const getNoBillingAccountResponse = {
  getBillingAccountUser: {
    billingAccounts: {
      edges: [],
    },
  },
};

export const GetBillingAccountUserQuerySuccess = graphql.query<
  GetBillingAccountUserQueryResult,
  GetBillingAccountUserQueryVariables
>('getBillingAccountUser', (_req, res, ctx) =>
  res(ctx.data(getBillingAccountUserQueryResponse))
);

export const GetBillingAccountsUserQuerySuccess = graphql.query<
  GetBillingAccountUserQueryResult,
  GetBillingAccountUserQueryVariables
>('getBillingAccountUser', (_req, res, ctx) =>
  res(ctx.data(getBillingAccountsUserQuerySuccess))
);

export const GetBillingAccountWithoutTermsUserQuerySuccess = graphql.query<
  GetBillingAccountUserQueryResult,
  GetBillingAccountUserQueryVariables
>('getBillingAccountUser', (_req, res, ctx) =>
  res(ctx.data(getBillingAccountWithoutTermsUserQueryResponse))
);

export const GetNoBillingAccountUserQuerySuccess = graphql.query<
  GetBillingAccountUserQueryResult,
  GetBillingAccountUserQueryVariables
>('getBillingAccountUser', (_req, res, ctx) =>
  res(ctx.data(getNoBillingAccountResponse))
);

const taxExemptions = [
  {
    id: '12345',
    client_id: '12345',
    billingAccountId: '0x123456',
    pdfUrl: '',
    document_type: {
      name: '',
    },
    exposure_zone: {
      name: faker.location.state(),
    },
    filename: '',
    signed_date: 'Dec 21st, 2021',
    expiration_date: 'Dec 21st, 2022',
    actual_tax_code: {
      name: 'EXPOSURE1234567',
    },
    expected_tax_code: {
      name: 'EXPOSURE1234567',
    },
    status: {
      name: 'EXPOSURE1234567',
    },
    billingAccountName: faker.company.name(),
  },
];

export const getTaxExemptionsQueryResponse = {
  getTaxExemptions: taxExemptions,
};

export const getMultiTaxExemptionsQueryResponse = {
  getTaxExemptions: [
    {
      id: '30366',
      client_id: '134789',
      billingAccountId: 'B13010',
      pdfUrl: '',
      document_type: {
        name: 'Sales and Use Tax',
        __typename: 'TaxExemptionSubObject',
      },
      actual_tax_code: {
        name: 'EXPOSURE: INVALID CERT',
        __typename: 'TaxExemptionSubObject',
      },
      expected_tax_code: {
        name: 'OTHER/CUSTOM',
        __typename: 'TaxExemptionSubObject',
      },
      exposure_zone: {
        name: 'Ohio',
        __typename: 'TaxExemptionSubObject',
      },
      status: {
        name: 'COMPLETE',
        __typename: 'TaxExemptionStatus',
      },
      filename: '134789_11474_30366.pdf',
      expiration_date: '2023-02-03',
      signed_date: '2023-02-03',
      billingAccountName: 'Bread Pitt Bakery, LLC',
      __typename: 'TaxExemption',
    },
    {
      id: '3116',
      client_id: '134789',
      billingAccountId: 'B13010',
      pdfUrl: '',
      document_type: {
        name: 'Sales and Use Tax',
        __typename: 'TaxExemptionSubObject',
      },
      actual_tax_code: {
        name: 'RESALE',
        __typename: 'TaxExemptionSubObject',
      },
      expected_tax_code: {
        name: 'RESALE',
        __typename: 'TaxExemptionSubObject',
      },
      exposure_zone: {
        name: 'Ohio',
        __typename: 'TaxExemptionSubObject',
      },
      status: {
        name: 'COMPLETE',
        __typename: 'TaxExemptionStatus',
      },
      filename: '134789_1785_3116.pdf',
      expiration_date: '9999-12-31',
      signed_date: '2020-02-07',
      billingAccountName: 'Bread Pitt Bakery, LLC',
      __typename: 'TaxExemption',
    },
    {
      id: '3116',
      client_id: '134789',
      billingAccountId: 'B13010',
      pdfUrl: '',
      document_type: {
        name: 'Sales and Use Tax',
        __typename: 'TaxExemptionSubObject',
      },
      actual_tax_code: {
        name: 'RESALE',
        __typename: 'TaxExemptionSubObject',
      },
      expected_tax_code: {
        name: 'RESALE',
        __typename: 'TaxExemptionSubObject',
      },
      exposure_zone: {
        name: 'Ohio',
        __typename: 'TaxExemptionSubObject',
      },
      status: {
        name: 'COMPLETE',
        __typename: 'TaxExemptionStatus',
      },
      filename: '134789_1785_3116.pdf',
      expiration_date: '9999-12-31',
      signed_date: '2020-02-07',
      billingAccountName: 'Bread Pitt Bakery, LLC',
      __typename: 'TaxExemption',
    },
    {
      id: '3116',
      client_id: '134789',
      billingAccountId: 'B13010',
      pdfUrl: '',
      document_type: {
        name: 'Sales and Use Tax',
        __typename: 'TaxExemptionSubObject',
      },
      actual_tax_code: {
        name: 'RESALE',
        __typename: 'TaxExemptionSubObject',
      },
      expected_tax_code: {
        name: 'RESALE',
        __typename: 'TaxExemptionSubObject',
      },
      exposure_zone: {
        name: 'Ohio',
        __typename: 'TaxExemptionSubObject',
      },
      status: {
        name: 'COMPLETE',
        __typename: 'TaxExemptionStatus',
      },
      filename: '134789_1785_3116.pdf',
      expiration_date: '9999-12-31',
      signed_date: '2020-02-07',
      billingAccountName: 'Bread Pitt Bakery, LLC',
      __typename: 'TaxExemption',
    },
    {
      id: '3116',
      client_id: '134789',
      billingAccountId: 'B53857',
      pdfUrl: '',
      document_type: {
        name: 'Sales and Use Tax',
        __typename: 'TaxExemptionSubObject',
      },
      actual_tax_code: {
        name: 'RESALE',
        __typename: 'TaxExemptionSubObject',
      },
      expected_tax_code: {
        name: 'RESALE',
        __typename: 'TaxExemptionSubObject',
      },
      exposure_zone: {
        name: 'Ohio',
        __typename: 'TaxExemptionSubObject',
      },
      status: {
        name: 'COMPLETE',
        __typename: 'TaxExemptionStatus',
      },
      filename: '134789_1785_3116.pdf',
      expiration_date: '9999-12-31',
      signed_date: '2020-02-07',
      billingAccountName: 'Pita Pan Inc',
      __typename: 'TaxExemption',
    },
  ],
};

export const GetTaxExemptionsQuerySuccess = graphql.query<
  GetTaxExemptionsQueryResult,
  GetTaxExemptionsQueryVariables
>('getTaxExemptions', (_req, res, ctx) =>
  res(ctx.data(getTaxExemptionsQueryResponse))
);

export const GetMultiTaxExemptionsQuerySuccess = graphql.query<
  GetTaxExemptionsQueryResult,
  GetTaxExemptionsQueryVariables
>('getTaxExemptions', (_req, res, ctx) =>
  res(ctx.data(getMultiTaxExemptionsQueryResponse))
);

export const DeleteTaxExemptionMutationQuerySuccess = graphql.mutation<
  DeleteTaxExemptionMutationResult,
  DeleteTaxExemptionMutationVariables
>('deleteTaxExemption', (_req, res, ctx) =>
  res(ctx.data({ deleteTaxExemption: true }))
);

export const DeleteTaxExemptionMutationQueryFailure = graphql.mutation<
  DeleteTaxExemptionMutationResult,
  DeleteTaxExemptionMutationVariables
>('deleteTaxExemption', (_req, res, ctx) =>
  res(
    ctx.errors([
      {
        message: 'Failed to delete tax exemption',
      },
    ])
  )
);

export const AddTaxExemptionUrlMutationQuerySuccess = graphql.mutation<
  AddTaxExemptionUrlMutationResult,
  AddTaxExemptionUrlMutationVariables
>('addTaxExemptionUrl', (_req, res, ctx) =>
  res(
    ctx.data({
      addTaxExemptionUrl: `${API_ORIGIN}/v2/users/${12345}/add-tax-exemption`,
    })
  )
);

export const AddTaxExemptionUrlMutationQueryFailure = graphql.mutation<
  AddTaxExemptionUrlMutationResult,
  AddTaxExemptionUrlMutationVariables
>('addTaxExemptionUrl', (req, res, ctx) =>
  res(
    ctx.errors([
      {
        message: 'An error occurred. Tax Exemption was not removed.',
      },
    ])
  )
);

export const PostAddTaxExemptionSuccess = rest.post(
  `${API_ORIGIN}/v2/users/:userId/add-tax-exemption`,
  (_req, res, ctx) => res(ctx.json({ data: {} }))
);

export const PostAddTaxExemptionError = rest.post(
  `${API_ORIGIN}/v2/users/${userId}/add-tax-exemption`,
  (_req, res, ctx) =>
    res(ctx.status(400), ctx.json({ error: `User ${userId} not found.` }))
);

export const SetBillingAccountAddressSuccess = graphql.mutation<
  SetBillingAccountAddressMutationResult,
  SetBillingAccountAddressMutationVariables
>('setBillingAccountAddress', (_req, res, ctx) =>
  res(
    ctx.data({
      setBillingAccountAddress: {
        billingAccount: {
          id: '12345',
          contact: {
            address: {
              street1: faker.location.streetAddress(),
              street2: faker.location.secondaryAddress(),
              city: faker.location.city(),
              state: faker.location.state({ abbreviated: true }),
              zipcode: faker.location.zipCode(),
              country: 'United States',
            },
          },
        },
      },
    })
  )
);

/* ===================================================== */
/* Mocked Data for Credit Application                    */
/* ===================================================== */

// Approved
export const createCreditAppApprovedResponse: CreateCreditApplicationMutationResult =
  {
    createCreditApplication: {
      id: 81,
      billingAccountId: 'B30000',
      acctsPayableEmail: 'sam.example@xometry.com',
      requestedTermLimit: 'Net 30',
      approvedAmount: 10000,
      decision: 'Approved',
    },
  };

// Invalid company info
export const createCreditAppInvalidCompanyInfoResponse: CreateCreditApplicationMutationResult =
  {
    createCreditApplication: {
      id: 72,
      billingAccountId: 'B30000',
      acctsPayableEmail: 'sam.example@xometry.com',
      requestedTermLimit: 'Net 30',
      approvedAmount: null,
      decision: 'Pend',
    },
  };

// Pending (DNB)
export const createCreditAppDNBPendingResponse: CreateCreditApplicationMutationResult =
  {
    createCreditApplication: {
      id: 80,
      billingAccountId: 'B30000',
      acctsPayableEmail: 'sam.example@xometry.com',
      requestedTermLimit: 'Net 30',
      approvedAmount: 10000,
      decision: 'Pend',
    },
  };

// Declined
export const createCreditAppDeclinedQuery: CreateCreditApplicationMutationResult =
  {
    createCreditApplication: {
      id: 83,
      billingAccountId: 'B30000',
      acctsPayableEmail: 'sam.example@xometry.com',
      requestedTermLimit: 'Net 30',
      approvedAmount: 10000,
      decision: 'Declined',
    },
  };

// Approved in DNB but Declined in Xometry
export const createCreditAppPendingQuery: CreateCreditApplicationMutationResult =
  {
    createCreditApplication: {
      id: 84,
      billingAccountId: 'B30000',
      acctsPayableEmail: 'sam.example@xometry.com',
      requestedTermLimit: 'Net 60',
      approvedAmount: 10000,
      decision: 'Pend',
    },
  };

/* ===================================================== */
/* Success Mock for Credit Application                   */
/* ===================================================== */

export const CreateCreditApplicationSuccessMock = graphql.mutation<
  CreateCreditApplicationMutationResult,
  CreateCreditApplicationMutationVariables
>('createCreditApplication', (req, res, ctx) =>
  res(ctx.delay(3000), ctx.data(createCreditAppApprovedResponse))
);

export const CreateCreditApplicationPendingMock = graphql.mutation<
  CreateCreditApplicationMutationResult,
  CreateCreditApplicationMutationVariables
>('createCreditApplication', (req, res, ctx) =>
  res(ctx.delay(3000), ctx.data(createCreditAppPendingQuery))
);

export const CreateCreditApplicationPendingDeclinedMock = graphql.mutation<
  CreateCreditApplicationMutationResult,
  CreateCreditApplicationMutationVariables
>('createCreditApplication', (req, res, ctx) =>
  res(ctx.delay(3000), ctx.data(createCreditAppDeclinedQuery))
);

export const CreateCreditApplicationFailureMock = graphql.mutation<
  CreateCreditApplicationMutationResult,
  CreateCreditApplicationMutationVariables
>('createCreditApplication', (req, res, ctx) => res(ctx.status(400)));

/* ===================================================== */
/* Success Mock for Submited Credit Application          */
/* ===================================================== */

export const HasUserSubmittedApplicationQueryTrue = graphql.query<
  HasUserSubmittedApplicationQueryResult,
  HasUserSubmittedApplicationQueryVariables
>('hasUserSubmittedApplication', (req, res, ctx) => {
  if (req.variables.billingAccountId === 'B58241') {
    return req.passthrough();
  }
  return res(
    ctx.data({
      hasUserSubmittedApplication: {
        isSubmitted: true,
        date: faker.date.recent(),
      },
    })
  );
});

export const HasUserSubmittedApplicationQueryFalse = graphql.query<
  HasUserSubmittedApplicationQueryResult,
  HasUserSubmittedApplicationQueryVariables
>('hasUserSubmittedApplication', (req, res, ctx) =>
  res(
    ctx.data({
      hasUserSubmittedApplication: {
        isSubmitted: false,
        date: faker.date.recent(),
      },
    })
  )
);

/* ===================================================== */
/* Mock Data for Billing Account Financials              */
/* ===================================================== */

export const mockInvoices: IntacctInvoice[] = [
  {
    __typename: 'IntacctInvoice',
    recordNo: 4646621,
    docNo: '4646621',
    whenCreated: '2025-03-24T00:00:00Z',
    whenDue: '2025-04-23T00:00:00Z',
    totalEntered: '269.76',
    totalDue: '269.76',
    state: 'Posted',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4555260,
    docNo: '4555260',
    whenCreated: '2025-02-25T00:00:00Z',
    whenDue: '2025-03-27T00:00:00Z',
    totalEntered: '138.80',
    totalDue: '138.80',
    state: 'Posted',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4527686,
    docNo: '4527686',
    whenCreated: '2025-02-17T00:00:00Z',
    whenDue: '2025-03-19T00:00:00Z',
    totalEntered: '540.29',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4522250,
    docNo: '4522250',
    whenCreated: '2025-02-14T00:00:00Z',
    whenDue: '2025-03-16T00:00:00Z',
    totalEntered: '5675.12',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4503064,
    docNo: '4503064',
    whenCreated: '2025-02-10T00:00:00Z',
    whenDue: '2025-03-12T00:00:00Z',
    totalEntered: '248.74',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4476308,
    docNo: '4476308',
    whenCreated: '2025-01-31T00:00:00Z',
    whenDue: '2025-03-02T00:00:00Z',
    totalEntered: '1839.41',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4468155,
    docNo: '4468155',
    whenCreated: '2025-01-29T00:00:00Z',
    whenDue: '2025-02-28T00:00:00Z',
    totalEntered: '341.00',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4460035,
    docNo: '4460035',
    whenCreated: '2025-01-27T00:00:00Z',
    whenDue: '2025-02-26T00:00:00Z',
    totalEntered: '647.38',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4419118,
    docNo: '4419118',
    whenCreated: '2025-01-11T00:00:00Z',
    whenDue: '2025-02-10T00:00:00Z',
    totalEntered: '392.03',
    totalDue: '338.33',
    state: 'Posted',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4352513,
    docNo: '4352513',
    whenCreated: '2024-12-19T00:00:00Z',
    whenDue: '2025-01-18T00:00:00Z',
    totalEntered: '718.64',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4337547,
    docNo: '4337547',
    whenCreated: '2024-12-15T00:00:00Z',
    whenDue: '2025-01-14T00:00:00Z',
    totalEntered: '570.98',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4264965,
    docNo: '4264965',
    whenCreated: '2024-11-20T00:00:00Z',
    whenDue: '2024-12-20T00:00:00Z',
    totalEntered: '1546.41',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4264645,
    docNo: '4264645',
    whenCreated: '2024-11-20T00:00:00Z',
    whenDue: '2024-12-20T00:00:00Z',
    totalEntered: '4039.66',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4243679,
    docNo: '4243679',
    whenCreated: '2024-11-13T00:00:00Z',
    whenDue: '2024-12-13T00:00:00Z',
    totalEntered: '205.33',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 4166755,
    docNo: '4166755',
    whenCreated: '2024-10-22T00:00:00Z',
    whenDue: '2024-11-21T00:00:00Z',
    totalEntered: '410.52',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
  {
    __typename: 'IntacctInvoice',
    recordNo: 2682270,
    docNo: '2682270',
    whenCreated: '2023-05-31T00:00:00Z',
    whenDue: '2023-06-30T00:00:00Z',
    totalEntered: '-4434.00',
    totalDue: '0.00',
    state: 'Paid',
    currency: 'USD',
    paymentProcessingStatus: null,
  },
];

export const mockPayments: IntacctPayment[] = [
  {
    __typename: 'IntacctPayment',
    recordNo: 1403634,
    customerId: 'C-11768',
    whenCreated: '2022-04-01T00:00:00Z',
    totalEntered: '3897.00',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4527686',
        amountApplied: '540.29',
      },
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4522250',
        amountApplied: '3356.71',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 1384908,
    customerId: 'C-11768',
    whenCreated: '2022-03-23T00:00:00Z',
    totalEntered: '2837.02',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4522250',
        amountApplied: '2318.41',
      },
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4503064',
        amountApplied: '248.74',
      },
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4476308',
        amountApplied: '269.87',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 569576,
    customerId: 'C-11768',
    whenCreated: '2021-03-04T00:00:00Z',
    totalEntered: '565.72',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4476308',
        amountApplied: '565.72',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 514167,
    customerId: 'C-11768',
    whenCreated: '2020-12-26T00:00:00Z',
    totalEntered: '0.01',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4460035',
        amountApplied: '0.01',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 454659,
    customerId: 'C-11768',
    whenCreated: '2020-11-20T00:00:00Z',
    totalEntered: '821.00',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4468155',
        amountApplied: '341.00',
      },
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4460035',
        amountApplied: '480.00',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 417030,
    customerId: 'C-11768',
    whenCreated: '2020-10-16T00:00:00Z',
    totalEntered: '53.70',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4419118',
        amountApplied: '53.70',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 349051,
    customerId: 'C-11768',
    whenCreated: '2020-08-07T00:00:00Z',
    totalEntered: '671.96',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4352513',
        amountApplied: '671.96',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 324613,
    customerId: 'C-11768',
    whenCreated: '2020-07-03T00:00:00Z',
    totalEntered: '717.00',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4352513',
        amountApplied: '46.68',
      },
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4337547',
        amountApplied: '570.98',
      },
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4264965',
        amountApplied: '99.34',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 280314,
    customerId: 'C-11768',
    whenCreated: '2020-05-01T00:00:00Z',
    totalEntered: '1029.29',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4264965',
        amountApplied: '1029.29',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 240928,
    customerId: 'C-11768',
    whenCreated: '2020-03-20T00:00:00Z',
    totalEntered: '469.53',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4264645',
        amountApplied: '469.53',
      },
    ],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 192159,
    customerId: 'C-11768',
    whenCreated: '2020-01-17T00:00:00Z',
    totalEntered: '849.31',
    unusedAmount: '849.31',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190001,
    customerId: 'C-11768',
    whenCreated: '2020-02-10T00:00:00Z',
    totalEntered: '320.00',
    unusedAmount: '320.00',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190002,
    customerId: 'C-11768',
    whenCreated: '2020-03-05T00:00:00Z',
    totalEntered: '475.50',
    unusedAmount: '475.50',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190003,
    customerId: 'C-11768',
    whenCreated: '2020-04-12T00:00:00Z',
    totalEntered: '150.75',
    unusedAmount: '150.75',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190004,
    customerId: 'C-11768',
    whenCreated: '2020-05-20T00:00:00Z',
    totalEntered: '999.99',
    unusedAmount: '999.99',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190005,
    customerId: 'C-11768',
    whenCreated: '2020-06-15T00:00:00Z',
    totalEntered: '612.30',
    unusedAmount: '612.30',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190006,
    customerId: 'C-11768',
    whenCreated: '2020-07-08T00:00:00Z',
    totalEntered: '88.00',
    unusedAmount: '88.00',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190007,
    customerId: 'C-11768',
    whenCreated: '2020-08-22T00:00:00Z',
    totalEntered: '1250.00',
    unusedAmount: '1250.00',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190008,
    customerId: 'C-11768',
    whenCreated: '2020-09-14T00:00:00Z',
    totalEntered: '530.45',
    unusedAmount: '530.45',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190009,
    customerId: 'C-11768',
    whenCreated: '2020-10-03T00:00:00Z',
    totalEntered: '200.00',
    unusedAmount: '200.00',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190010,
    customerId: 'C-11768',
    whenCreated: '2020-11-01T00:00:00Z',
    totalEntered: '415.60',
    unusedAmount: '415.60',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 190011,
    customerId: 'C-11768',
    whenCreated: '2020-12-19T00:00:00Z',
    totalEntered: '780.00',
    unusedAmount: '780.00',
    currency: 'USD',
    allocations: [],
  },
  {
    __typename: 'IntacctPayment',
    recordNo: 173884,
    customerId: 'C-11768',
    whenCreated: '2019-12-13T00:00:00Z',
    totalEntered: '5197.81',
    unusedAmount: '0.00',
    currency: 'USD',
    allocations: [
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4264645',
        amountApplied: '3570.13',
      },
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4243679',
        amountApplied: '205.33',
      },
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '4166755',
        amountApplied: '410.52',
      },
      {
        __typename: 'IntacctPaymentAllocation',
        invoiceRecordNo: '2682270',
        amountApplied: '1011.83',
      },
    ],
  },
];

export const mockCreditMemos: IntacctCreditMemo[] = [
  {
    __typename: 'IntacctCreditMemo',
    recordNo: 6001001,
    docNo: 'CM-2025-001',
    whenCreated: '2025-03-01T00:00:00Z',
    totalEntered: '-500.00',
    totalDue: '0.00',
    state: 'Posted',
    currency: 'USD',
    description: 'Return credit - defective parts',
  },
  {
    __typename: 'IntacctCreditMemo',
    recordNo: 6001002,
    docNo: 'CM-2025-002',
    whenCreated: '2025-01-20T00:00:00Z',
    totalEntered: '-125.00',
    totalDue: '0.00',
    state: 'Posted',
    currency: 'USD',
    description: 'Shipping refund',
  },
  {
    __typename: 'IntacctCreditMemo',
    recordNo: 6001003,
    docNo: null,
    whenCreated: '2024-11-15T00:00:00Z',
    totalEntered: '-1200.00',
    totalDue: '-1200.00',
    state: 'Posted',
    currency: 'USD',
    description: 'Volume discount adjustment',
  },
];

export const getBillingAccountFinancialsResponse = {
  getBillingAccount: {
    __typename: 'BillingAccount',
    id: 'B12345',
    name: 'Test Company LLC',
    invoices: mockInvoices,
    payments: mockPayments,
    creditMemos: mockCreditMemos,
  },
};

export const GetBillingAccountFinancialsQuerySuccess = graphql.query<
  GetBillingAccountFinancialsQueryResult,
  GetBillingAccountFinancialsQueryVariables
>('getBillingAccountFinancials', (_req, res, ctx) =>
  res(ctx.data(getBillingAccountFinancialsResponse))
);

export const GetBillingAccountFinancialsQueryEmpty = graphql.query<
  GetBillingAccountFinancialsQueryResult,
  GetBillingAccountFinancialsQueryVariables
>('getBillingAccountFinancials', (_req, res, ctx) =>
  res(
    ctx.data({
      getBillingAccount: {
        __typename: 'BillingAccount',
        id: 'B12345',
        name: 'Test Company LLC',
        invoices: [],
        payments: [],
        creditMemos: [],
      },
    })
  )
);

// ============================================================================
// Pay Invoices Mutation Mocks
// ============================================================================

export const PayInvoicesMutationSuccess = graphql.mutation<
  PayInvoicesMutationResult,
  PayInvoicesMutationVariables
>('payInvoices', (_req, res, ctx) =>
  res(
    ctx.data({
      payInvoices: {
        __typename: 'InvoicePaymentResult',
        successful: true,
        chargeId: 'ch_mock_123',
        errorMessage: null,
      },
    })
  )
);

export const PayInvoicesMutationFailure = graphql.mutation<
  PayInvoicesMutationResult,
  PayInvoicesMutationVariables
>('payInvoices', (_req, res, ctx) =>
  res(
    ctx.data({
      payInvoices: {
        __typename: 'InvoicePaymentResult',
        successful: false,
        chargeId: null,
        errorMessage:
          'Your card was declined. Please try a different payment method.',
      },
    })
  )
);

export const mockInvoiceProcessing: IntacctInvoice = {
  __typename: 'IntacctInvoice',
  recordNo: 4646622,
  docNo: '4646622',
  whenCreated: '2025-03-25T00:00:00Z',
  whenDue: '2025-04-24T00:00:00Z',
  totalEntered: '1250.00',
  totalDue: '1250.00',
  state: 'Posted',
  currency: 'USD',
  paymentProcessingStatus: 'PROCESSING',
};

export const mockInvoicesWithProcessing: IntacctInvoice[] = [
  mockInvoiceProcessing,
  ...mockInvoices,
];

export const GetBillingAccountFinancialsWithProcessing = graphql.query<
  GetBillingAccountFinancialsQueryResult,
  GetBillingAccountFinancialsQueryVariables
>('getBillingAccountFinancials', (_req, res, ctx) =>
  res(
    ctx.data({
      getBillingAccount: {
        __typename: 'BillingAccount',
        id: 'B12345',
        name: 'Test Company LLC',
        invoices: mockInvoicesWithProcessing,
        payments: mockPayments,
        creditMemos: mockCreditMemos,
      },
    })
  )
);
